import React from 'react'
import styled from 'styled-components'

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
  alt: string
  className?: string
  style?: React.CSSProperties
}

const StyledImage = styled.img`
  width: 50%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: inherit;
  display: block;
  max-width: 100%;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  @media (max-width: 1024px) {
    height: auto;
    max-height: 300px;
  }
  @media (max-width: 768px) {
    max-height: 220px;
  }
  @media (max-width: 480px) {
    max-height: 160px;
  }
`

export const Image: React.FC<ImageProps> = ({
  src,
  alt,
  className,
  style,
  ...rest
}) => (
  <StyledImage
    src={src}
    alt={alt}
    className={className}
    style={style}
    loading='lazy'
    {...rest}
  />
)
